import React, { Component } from "react";
import { PiMagnifyingGlass } from "react-icons/pi";
import { Modal, Form, Table, InputGroup, FormControl } from "react-bootstrap";

import axios from "../../axios";
import apiError from "../../error";

import "./customgroup-modal.css";
import axiosRequest from "axios";
import Pagination from "react-js-pagination";
import { getCookie } from "../../function";
import Loader from "../loader/loader";
import { debounce } from "../../function";
var cancelRequest = undefined, CancelToken = axiosRequest.CancelToken;

export default class SearchUserModal extends Component {
	constructor(props) {
		super(props);
		this.isTAconnected = getCookie('isTAconnected');
		this.state = {
			page: 1,
			limit: 10,
			search: "",
			targets: [],
			totalTargetCount: 0,
			loading: false,
			selectedPages: {},
		};
	}

	load = debounce(() => {
		this.fetchLocalTargets();
	}, 500)

	fetchUsersFromTA = () => {
		this.setState({ loading: true });
		if (cancelRequest) cancelRequest();
		axios.get('/api/adminCentral/list-users', {
			params: {
				page: this.state.page,
				limit: this.state.limit,
				search: this.state.search
			},
			cancelToken: new CancelToken(function executor(c) { cancelRequest = c })
		})
			.then(async (res) => {
				this.setState({
					loading: false,
					totalTargetCount: res.data?.response?.userCount ?? 0,
					targets: res.data?.response?.users ?? [],
				})
			})
			.catch(error => {
				if (!axiosRequest.isCancel(error)) {
					this.setState({ totalTargetCount: 0, loading: false });
					apiError(error);
				}
			});
	}

	fetchLocalTargets = () => {
		this.setState({ loading: true });
		if (cancelRequest) cancelRequest();
		axios.get('/api/targets/fetchAll/' + (this.props.selectedGroupId || 0), {
			params: {
				page: this.state.page,
				limit: this.state.limit,
				search: this.state.search
			},
			cancelToken: new CancelToken(function executor(c) { cancelRequest = c })
		})
			.then(async (res) => {
				this.setState({
					loading: false,
					totalTargetCount: res.data?.response?.totalTargetsCount ?? 0,
					targets: res.data?.response?.targets ?? [],
				})
			})
			.catch(error => {
				if (!axiosRequest.isCancel(error)) {
					this.setState({ totalTargetCount: 0, loading: false });
					apiError(error);
				}
			});
	}

	componentDidUpdate(prevProps, prevState) {
		if (prevState.search !== this.state.search) {
			this.setState({ page: 1 }, () => {
				this.load();
			})
		}

		if (prevProps.show !== this.props.show) {
			if (this.props.show) {
				this.props.setSelectedTargets([]);
				this.load();
			} else {
				this.setState({
					page: 1,
					limit: 10,
					search: "",
					selectedPages: {}
				});
			}
		}
	}

	handleCheckboxChange = (target) => {
		const { selectedTargets } = this.props;
		let updatedTargets;
		if (selectedTargets.some(selected => selected.id === target.id)) {
			// If selected, remove it
			updatedTargets = selectedTargets.filter(selected => selected.id !== target.id);
		} else {
			// If not selected, add it
			updatedTargets = [...selectedTargets, target];
		}
		let isPageSelected = this.state.targets.every(el => updatedTargets.includes(el));
		if (isPageSelected) {
			this.setState((prevState) => ({
				selectedPages: {
					...prevState.selectedPages,
					[this.state.page]: 1
				}
			}));
		} else {
			this.setState((prevState) => ({
				selectedPages: {
					...prevState.selectedPages,
					[this.state.page]: 0
				}
			}));
		}

		this.props.setSelectedTargets(updatedTargets);
	}

	isTargetSelected = (targetId) => {
		return this.props.selectedTargets.some(target => target.id === targetId);
	}

	handleCloseModal = () => {
		this.props.onCloseHandler()
		this.setState({ limit: 10, search: "", page: 1 });
	}
	handleAddUser = () => {
		if (this.props.selectedGroupId) {
			this.setState({ loading: true });
			axios.post('/api/groups/assign-targets', { groupId: this.props.selectedGroupId, targets: this.props.selectedTargets })
				.then(res => {
					this.props.setSelectedTargets([]);
					this.handleCloseModal();
					this.setState({ loading: false });
				})
				.catch(error => { this.setState({ loading: false }); apiError(error) });
		} else {
			this.handleCloseModal();
			this.setState({ loading: false })
		}
	}
	handlePageSelect = () => {
		const { selectedPages, page, targets } = this.state;
		const { selectedTargets, setSelectedTargets } = this.props;
		if (selectedPages[page]) {
			const updatedTargets = selectedTargets.filter(
				(target) => !targets.some(t => t.id === target.id)
			);
			setSelectedTargets(updatedTargets);
			this.setState((prevState) => ({
				selectedPages: {
					...prevState.selectedPages,
					[this.state.page]: 0
				}
			}));
		} else {
			const updatedTargets = [...new Set([...selectedTargets, ...targets])];
			setSelectedTargets(updatedTargets);
			this.setState((prevState) => ({
				selectedPages: {
					...prevState.selectedPages,
					[this.state.page]: 1
				}
			}));
		}
	};


	render() {
		return (
			<>
				<Modal className="info-filter right mainfooterModal right-modal-wrap"
					show={this.props.show}
					onHide={() => { this.handleCloseModal(); this.props.setSelectedTargets([]); }}
					autoFocus
					keyboard
				>
					<Modal.Header closeButton>
						<div>
							<h5>Search User</h5>
							<p>Select users to add to the group</p>
						</div>
					</Modal.Header>

					<div className="filter-wrapper">
						<div className="alignItemsCenter row">
							<div className="col-md-3 p-0">
								<div className="positionSearchIcon">
									<InputGroup className="search-wrap">
										<FormControl
											type="text"
											placeholder="Search"
											value={this.state.search}
											onChange={(e) => this.setState({ search: e.target.value })}

											className="inputSearch mr-sm-2 form-control"
										/>
										<PiMagnifyingGlass className="search-icon"></PiMagnifyingGlass>
									</InputGroup>
								</div>
							</div>
							<div className="col-sm-9 p-0"></div>
						</div>
					</div>

					<Modal.Body>
						<div className="custominfoBox">
							<div className="tableContainerWrapInner">
								<Table responsive>
									<thead className="bg-light">
										<tr>
											<th className="w-5" onClick={this.handlePageSelect}><Form.Check type="checkbox" checked={this.state.selectedPages[this.state.page]} /></th>
											<th>Name</th>
											<th>Designation</th>
										</tr>
									</thead>

								<tbody>
									{this.state.targets?.map(target => (
										<tr key={target.id}>
											<td>
												<Form.Check
													type="checkbox"
													checked={this.isTargetSelected((target.IdentityKey || target.id))}
													onChange={() => this.handleCheckboxChange(target)}
												/>
											</td>
											<td className="onlyForPinter">
												<div className="flexTableData">
													<div className="circle">
														<p className="circle-inner">{target.firstname[0]}</p>
													</div>
													<div>
														<h6>{target.firstname} {target.lastname}</h6>
														<span>{target.email}</span>
													</div>
												</div>
											</td>
											<td>{target.designation || target.position}</td>
										</tr>
									))}
								</tbody>
								</Table>
								<div className="pagination-Wrap">
									<div className="row">
										<div className="col-md-6">
											{!this.state['loading'] ?
												<Pagination
													itemClass="page-item"
													linkClass="page-link"
													activePage={this.state.page}
													itemsCountPerPage={this.state.limit}
													totalItemsCount={this.state.totalTargetCount}
													onChange={(pageNumber) => this.setState({ page: pageNumber }, () => this.load())}
												/> : "Loading..."
											}
										</div>
										<div className="col-md-6 text-right d-flex align-items-center footer-pg">
											<div className="w-100 pgCount"><p>Total No Of Users: {this.state.totalTargetCount} </p> </div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</Modal.Body>

					<div className="modalFooter">
						<div className="row">
							<div className="col-md-12 text-right">
								<button type="button" className="btn closeBtn" onClick={() => { this.handleCloseModal(); this.props.setSelectedTargets([]); }}>Cancel</button>
								<button
									disabled={this.props.selectedTargets?.length === 0}
									type="button"
									className="btn btn-success ml-2 btn btn-primary"
									onClick={this.handleAddUser}
								>
									<div className="spinner-border d-none" role="status"></div>
									Add Users
								</button>
							</div>
						</div>
					</div>
				</Modal>
				{this.state.loading ? <Loader></Loader> : null}
			</>
		);
	}
}
